export default {
  hello: '你好',
  lookup: {
    title: '基础数据列表',
    lookupId: '数据id',
    lookupCode: '数据简码',
    orgId: '组织id',
    lookupName: '名称',
    lookupNameZh: '名称-中文',
    lookupNameEn: '名称-英文',
    lookupDesc: '数据描述',
    update: '编辑数据',
    create: '创建数据'
  },
  lookupItem: {
    title: '基础数据项列表',
    lookupId: '数据id',
    lookupItemId: '数据项id',
    lookupItemOrder: '数据项顺序',
    lookupItemCode: '数据项编码',
    lookupItemName: '名称',
    lookupItemNameZh: '名称-中文',
    lookupItemNameEn: '名称-英文',
    lookupItemDesc: '数据项描述',
    update: '编辑数据项',
    create: '创建数据项'
  },
  subjects: {
    subjectName: '请填写科目名称'
  },
  course: {
    schoolId: '请选择学校',
    subjectId: '请选择科目',
    gradeId: '请选择年级',
    courseId: '请选择课程',
    courseName: '请输入课程名'
  },
  methods: {
    methodName: '请填写方法名称'
  },
  types: {
    typeName: '请填写类型名称'
  },
  standard: {
    subjectId: '请选择科目',
    standardId: '请选择教学标准',
    standardName: '请填写教学标准名称',
    versionName: '请填写版本名称',
    fileName: '请上传文件'
  }
}



// WEBPACK FOOTER //
// ./src/views/admin/lang/zh.js